import { SubmitInput, Button } from './styles';

export const SubmitButton = ({ ...props }) => <Button {...props}><SubmitInput type="submit" /></Button>
